import {
  ID,
  MEDIA_HM_PATH,
  STATIC_HM_PATH,
  UslugaFindByUrlResponse,
} from "@project/shared-types";
import { useContext, useMemo } from "react";
import { useLoaderData, useLocation } from "react-router";
import Clock from "../../assets/taiga-uikit/icons/clock.svg?react";
import { BreadCrumbs } from "../../components/BreadCrumbs/BreadCrumbs";
import { Link } from "../../components/link/link";
import PreloadImage from "../../components/PreloadImage/PreloadImage";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { TypingText } from "../../components/TypingText/TypingText";
import {
  _colorText,
  _size,
  _sizeHeading,
  _sizeText,
  _style,
} from "../../core/core";
import { DataContext } from "../../hooks/DataContext";
import "./MainBlock.css";
interface MainBlockProps {
  block: any;
  product_id: ID;
  [key: string]: any;
}

export const MainBlock = ({ block, product_id, ...props }: MainBlockProps) => {
  const data = useLoaderData<UslugaFindByUrlResponse>();
  const { products } = useContext(DataContext);
  const product = useMemo(
    () => products.find((p) => p.id === data.usluga?.product_id),
    [data, products]
  );
  const currentPage = useLocation();
  const breadLinks = [
    { url: "/", name: "Главная" },
    { url: "/uslugi/", name: `Услуги` },
    { url: currentPage.pathname, name: `  ${block.place_name}` },
  ];
  return (
    <>
      <BreadCrumbs links={breadLinks}></BreadCrumbs>
      <div className={"main-block "}>
        {
          <PreloadImage
            imageSrc={`${STATIC_HM_PATH}/images/service_${data.usluga?.id}.webp`}
            alt={`${block.title} картинка`}
            className={"m-img "}
          ></PreloadImage>
        }
        <div className="bodymain">
          <div className="m-head">
            <div className="m-head-mob">
              <Text color={_colorText.black} size={_sizeText.m}>
                {block.avg_time}
              </Text>
              <img
                src={`${MEDIA_HM_PATH}${product?.icon}`}
                alt={`${block.place_name} иконка svg`}
              ></img>
            </div>
            <div className="m-head-r">
              <img
                src={`${MEDIA_HM_PATH}${product?.icon}`}
                alt={`${block.place_name} иконка svg`}
              ></img>
              <Text size={_sizeText.m} color={_colorText.black}>
                {block.place_name}
              </Text>
            </div>
            <div className="m-head-l">
              <Clock></Clock>
              <Text color={_colorText.black} size={_sizeText.m}>
                {block.avg_time}
              </Text>
            </div>
          </div>
          <div className="main">
            <Text size={_sizeText.m} color={_colorText.default}>
              {block.min_title}
            </Text>
            <TypingText
              texts={[block.title]}
              typingSpeed={50}
              pauseTime={100000}
            >
              <Title
                is_h1
                color={_colorText.default}
                type={_sizeHeading.h2}
              ></Title>
            </TypingText>
            <div className="main-group">
              <Text size={_sizeText.m} color={_colorText.default}>
                Распределим по времени
              </Text>
              <Text size={_sizeText.m} color={_colorText.default}>
                •
              </Text>
              <Text size={_sizeText.m} color={_colorText.default}>
                Фото и текст, если нужно
              </Text>
              <Text size={_sizeText.m} color={_colorText.default}>
                •
              </Text>
              <Text size={_sizeText.m} color={_colorText.default}>
                Гарантия год
              </Text>
            </div>
          </div>
        </div>
        <Link link={block.button_url} style={_style.secondary} size={_size.M}>
          {block.button_text}
        </Link>
      </div>
    </>
  );
};
